import { HttpClientEngineCapability33x11oaa7ywe5 as HttpClientEngineCapability } from '../../engine/HttpClientEngineCapability.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SSECapabilityClass;
function SSECapability() {
  if (SSECapabilityClass === VOID) {
    class $ {
      toString() {
        return 'SSECapability';
      }
      hashCode() {
        return -177755299;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SSECapability()))
          return false;
        return true;
      }
    }
    initMetadataForObject($, 'SSECapability', VOID, VOID, [HttpClientEngineCapability()]);
    SSECapabilityClass = $;
  }
  return SSECapabilityClass;
}
var SSECapability_instance;
function SSECapability_getInstance() {
  return SSECapability_instance;
}
//region block: init
SSECapability_instance = new (SSECapability())();
//endregion
//region block: exports
export {
  SSECapability_instance as SSECapability_instance2x56e2kozv2rg,
};
//endregion

//# sourceMappingURL=SSE.mjs.map
